/*  控件常用监听操作
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：王哲                           创建日期：2014/03/24
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 常用控件的监听程序：包括
 进入事件
 变更事件
 离开事件
 点击事件
 表格点击事件
 树控件点击事件
 *******************************************************************************/
import { AllCompGUID, sgiLogger } from 'rt-sd-common';
import { getFunctionByKey } from './sgiBaseComp/SgiCommon';

var SgiEventHandler = {
    /**
     * 点击事件
     *
     * @param {type}
     *            ctl 控件本身
     * @param {type}
     *            eo 事件
     */
    onClick: function (eo) {

        try {
            sgiLogger.eventin(eo);
            tool.sgiLogger.log('点击事件入口');

            var { objFct } = this.props;
            //2020 7.14增加重复点击功能
            const that = this   // 为定时器中的setState绑定this
            var { repeatClickFlag } = this.state;
            if (repeatClickFlag) {
                return;
            } else {
                this.setState({ repeatClickFlag: true });
            }
            setTimeout(function () {       // 设置延迟事件，1秒后将执行
                that.setState({ repeatClickFlag: false })   // 将isClick设置为true
            }, 500);

            let onClick = getFunctionByKey(this, "onClick");
            if (onClick) {
                onClick(this, objFct);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 进入事件
     *
     * @param {type}
     *            ctl 控件本身
     * @param {type}
     *            eo 事件
     */
    onFocus: function (currentModule, eo) {
        try {
            sgiLogger.eventin(eo);
            tool.sgiLogger.log('进入事件入口');
            var { objFct } = currentModule.props;
            // let onFocus = currentModule.data.functions.onFocus;
            let onFocus = getFunctionByKey(currentModule, "onFocus");
            if (onFocus) {
                onFocus(currentModule, objFct);
            }
            if (currentModule._onFocus) {
                currentModule._onFocus();
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }

    },
    /**
     * 焦点离开监听
     *
     * @param {type}
     *            ctl 控件本身
     * @param {type}
     *            eo 事件
     */
    onBlur: function (currentModule, eo) {
        try {
            sgiLogger.eventin(eo);
            tool.sgiLogger.log('离开事件入口');
            var { objFct } = currentModule.props;
            // let onBlur = currentModule.data.functions.onBlur;
            let onBlur = getFunctionByKey(currentModule, "onBlur");
            if (onBlur) {
                onBlur(currentModule, objFct);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 修改监听
     *
     * @param {type}
     *            ctl 控件
     * @param {type}
     *            nV 新值
     * @param {type}
     *            oV 旧值
     * @returns {undefined}
     */
    onChange: function (currentModule, e, e2, e3) {
        try {
            tool.sgiLogger.log("change进入");
            var { moduleDesc, bdInst, objFct, type } = currentModule.props;
            var mdType = moduleDesc.desId;
            var newvalue, valueItem = {};
            if (mdType === AllCompGUID.DATE) {//日期
                newvalue = handleOnSelDate(currentModule, moduleDesc.c, bdInst, objFct, e, e2, moduleDesc.dateFmt);
            } else if (mdType === AllCompGUID.NUMBER) {//数字
                newvalue = handleOnNumberChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            } else if (mdType === AllCompGUID.TIME) {//时间
                newvalue = handleOnSelTime(currentModule, moduleDesc.c, bdInst, objFct, e, e2, moduleDesc.dateFmt);
            } else if (mdType === AllCompGUID.UPLOADFILE) {//上传
                newvalue = handleOnFileChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            } else if (mdType === AllCompGUID.CHECKBOXGROUP) {//复选框组
                newvalue = handleCheckBoxGroupChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            } else if (mdType === AllCompGUID.CHECKBOX) {//复选框
                newvalue = handleCheckBoxChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            } else if (mdType === AllCompGUID.COMBOXTREE) {//下拉树
                valueItem = handleOnTreeSelectChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2, e3) || {};
                newvalue = valueItem.value;
            } else if (mdType === AllCompGUID.COMBOBOX) {//下拉窗
                //多选的时候 e是选中事件还是取消选中的标志
                valueItem = handleOnComboxChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2) || {};
                newvalue = valueItem.value;
            } else if (mdType === AllCompGUID.CASCADER) {//级联组件
                //多选的时候 e是选中事件还是取消选中的标志
                valueItem = handleOnCascaderChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2);
                newvalue = valueItem.value;
            } else if (mdType === AllCompGUID.EDITOR) {//富文本
                newvalue = handleOnEditorChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            } else if (mdType === AllCompGUID.TINYMCE) {//tinymce富文本
                newvalue = handleOnTinyMCEChange(currentModule, moduleDesc.c, bdInst, objFct, e, e2);
            } else if (mdType === AllCompGUID.CODEMIRROR_FORM) {//codemirror
                newvalue = e3;
                currentModule.ctlRefresh(moduleDesc.c, bdInst, objFct, newvalue);
            } else {
                //调用统一  修改事件
                newvalue = handleOnChange(currentModule, moduleDesc.c, bdInst, objFct, e);
            }

            // //调用自定义事件
            // if (mdType === AllCompGUID.UPLOADFILE) {//文件控件特殊处理，添加status参数
            //     let onChange = currentModule.data.functions.onChange;
            //     if (onChange) {
            //         sgiLogger.eventin('修改');
            //         let status;
            //         if (e && e.file && e.file.status) {
            //             status = e.file.status;
            //         }
            //         onChange(currentModule, objFct, newvalue, objFct.get(bdInst), status);
            //     }
            // } else {//通用方式
            //     let onChange = currentModule.data.functions.onChange;
            //     if (onChange) {
            //         sgiLogger.eventin('修改');
            //         onChange(currentModule, objFct, newvalue, objFct.get(bdInst));
            //     }
            // }

            //调用自定义事件
            // let onChange = currentModule.data.functions.onChange;
            let onChange = getFunctionByKey(currentModule, "onChange");
            if (onChange) {
                sgiLogger.eventin('修改');
                let bdInstData;
                if (typeof bdInst === "string") {
                    if (type === "tb") {//兼容表格内自定义组件自定义修改事件
                        const bdInstKeyList = bdInst.split('`');
                        const bdInstList = objFct.get(bdInstKeyList[0]);
                        if (bdInstList && bdInstList[parseInt(bdInstKeyList[1])]) {
                            bdInstData = bdInstList[parseInt(bdInstKeyList[1])];
                        }
                    } else {
                        bdInstData = objFct.get(bdInst);
                    }
                } else {
                    bdInstData = bdInst;
                }

                if (mdType === AllCompGUID.UPLOADFILE) {//上传控件
                    onChange(currentModule, objFct, bdInstData, newvalue, e.file, e.file.response, e.fileList);
                } else if (mdType === AllCompGUID.CODEMIRROR_FORM) {//codemirror
                    onChange(currentModule, objFct, bdInstData, newvalue, e2, e);
                } else {
                    onChange(currentModule, objFct, bdInstData, newvalue, valueItem.title, valueItem.itemData, e2);
                }
            }

        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },

    /**
     * codemirror修改事件
     * @param {*} editor 
     * @param {*} data 
     * @param {*} value 
     */
    onCodeMirrorChange: function (editor, data, value) {
        try {
            sgiLogger.debug("codemirror修改事件入口");
            var { objFct } = this.props;
            let onChange = getFunctionByKey(this, "onChange");
            if (onChange) onChange(this, objFct, value, data, editor);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },

    /**
     * jsoneditor修改事件
     * @param {object} editor jsoneditor实例
     * @param {string} text json字符串
     * @param {json} json json对象|数组
     */
    onJsoneditorChange: function (editor, text, json) {
        try {
            sgiLogger.debug("jsoneditor修改事件入口");
            var { objFct } = this.props;
            let onChange = getFunctionByKey(this, "onChange");
            if (onChange) onChange(this, editor, objFct, text, json);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },

    /**
     * 菜单控件 MenuItem 点击事件
     * @param  {[type]} item [description]
     * @return {[type]}      [description]
     */
    menuClick: function (item) {
        try {
            // tool.sgiLogger.log(arguments);
            // tool.sgiLogger.log("menuClick:", item);
            tool.sgiLogger.log('菜单点击事件入口');
            var { objFct } = this.props;
            // let onClick = this.data.functions.onClick;
            let onClick = getFunctionByKey(this, "onClick");
            if (onClick) {
                onClick(this, objFct, item.item.props.itemData, item);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 弹出窗自定义单击监听
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onSearch: function (value) {
        try {
            tool.sgiLogger.log(' 弹出窗自定义点击事件入口');
            var { objFct } = this.props;
            // let onSearch = this.data.functions.onSearch;
            let onSearch = getFunctionByKey(this, "onSearch");
            if (onSearch) {
                onSearch(this, objFct, value);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 表格、树选择监听
     *
     * @param {type}
     *            ctl
     * @param {type}
     *            r
     * @param {type}
     *            index
     * @returns {undefined}
     */
    select: function (ctl, r, index) {
        try {
            // tool.sgiLogger.log(arguments);
            tool.sgiLogger.log('点击表格事件入口');
            // tool.sgiLogger.log(this.data.functions);
            let tcl = this.data.functions.tab;
            if (tcl) {
                tcl();
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 树单击监听
     *
     * @param {type}
     *            selectedKeys
     * @param {type}
     *            info
     * @returns {undefined}
     */
    itemclick: function (selectedKeys, e) {
        try {
            tool.sgiLogger.log('点击树事件入口');
            this.state.selectedKeys = selectedKeys;
            // this.state.checkedKeys = selectedKeys;
            this.setState({ loading: false });
            // tool.sgiLogger.log('selected', selectedKeys, e);

            // this.state.checkedNodes = [];
            this.state.selectedNodes = [];
            let checkedNodes = e.selectedNodes || e.checkedNodes
            // if (checkedNodes) checkedNodes.forEach(element => {
            //     this.state.checkedNodes.push(element.props.itemData);
            // })

            if (checkedNodes) checkedNodes.forEach(element => {
                this.state.selectedNodes.push(element.props.itemData);
            })

            //当前操作节点，当前treeNode
            var record = e.node.props.itemData;
            var treeNode = e.node.props;

            tool.sgiLogger.log("record", record);

            var { objFct } = this.props;
            // let onSelect = this.data.functions.onSelect;
            let onSelect = getFunctionByKey(this, "onSelect");
            if (onSelect) {
                onSelect(this, objFct, record, treeNode, e);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 树双击事件
     * @param {*} e 
     * @param {*} node 
     */
    itemDoubleClick: function (e, node) {
        try {
            tool.sgiLogger.log('树双击事件');

            var record = node.props.itemData;
            var treeNode = node.props;
            var { objFct } = this.props;

            tool.sgiLogger.log("record", record);

            // let onDoubleClick = this.data.functions.onDoubleClick;
            let onDoubleClick = getFunctionByKey(this, "onDoubleClick");
            if (onDoubleClick) {
                onDoubleClick(this, objFct, record, treeNode, node, e);
            }

        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 树勾选监听
     *
     * @param {type}
     *            checkedKeys
     * @param {type}
     *            info
     * @returns {undefined}
     */
    itemCheck: function (checkedKeys, e) {
        try {
            tool.sgiLogger.log('勾选树事件入口');

            //当前操作节点，当前treeNode
            var record = e.node.props.itemData;
            var treeNode = e.node.props;
            var { objFct } = this.props;

            tool.sgiLogger.log("record", record);

            // let onCheck = this.data.functions.onCheck;
            let onCheck = getFunctionByKey(this, "onCheck");
            if (onCheck) {
                onCheck(this, objFct, record, treeNode, e.checked, e);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 树右键点击事件
     * @param {object} { event, node } 
     */
    itemRightClick: function ({ event, node }) {
        try {
            tool.sgiLogger.log('右键点击事件入口');

            let treeNode = node.props;
            let record = treeNode.itemData;
            let { objFct } = this.props;

            // let onRightClick = this.data.functions.onRightClick;
            let onRightClick = getFunctionByKey(this, "onRightClick");

            //右键菜单 是否可以点击
            let rightMenuFlag = true;
            if (onRightClick) {
                rightMenuFlag = onRightClick(this, objFct, record, treeNode);
            }

            if (rightMenuFlag) {
                this.setState({
                    rightClickNodeTreeItem: {
                        pageX: event.pageX,
                        pageY: event.pageY,
                        record: record,
                        treeNode: treeNode
                    },
                    ContextMenuVisible: undefined
                });
            } else {
                this.setState({
                    ContextMenuVisible: "none"
                });
            }

        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 树右键菜单点击事件
     * @param {object} record 当前树节点数据对象
     * @param {object} e 事件对象
     */
    menuOnClick: function (record, e) {
        try {
            tool.sgiLogger.log('菜单点击事件 record :', record);

            let { key } = this.state;
            let treeNode = this.state.keysTreeNode[record[key]].props;

            this.setState({ ContextMenuVisible: "none" })

            let onClick = this.state.menuFuns[e.key];
            if (onClick) {
                let { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
                onClick(this, objFct, record, treeNode);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 表格单击监听
     *
     * @param {type} 当前选中行对象
     *            record
     * @param {type} 行序号/索引，从0开始
     *            index
     * @returns {undefined}
     */
    tableClick: function (record, index) {
        try {
            tool.sgiLogger.log('表格单击事件', record, index);
            //选择9的时候 没有单选多选控件的时候 点击放入选中数据
            if (this.props.moduleDesc.rowSMd == '9') {
                this.setState.selectedRows = [record];
            }

            var { objFct } = this.props;
            // let onRowClick = this.data.functions.onRowClick;
            let onRowClick = getFunctionByKey(this, "onRowClick");
            if (onRowClick) {
                onRowClick(this, objFct, record, index);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 双击监听
     *
     * @param {type}
     *            ctl
     * @param {type}
     *            r
     * @param {type}
     *            item
     * @param {type}
     *            ind
     * @returns {undefined}
     */
    itemdblclick: function (record, index) {
        try {
            tool.sgiLogger.log('表格双击事件', record, index);
            // this.setState({ selectedRows: [record] });
            var { objFct } = this.props;
            // let onRowDoubleClick = this.data.functions.onRowDoubleClick;
            let onRowDoubleClick = getFunctionByKey(this, "onRowDoubleClick");
            if (onRowDoubleClick) {
                onRowDoubleClick(this, objFct, record, index);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 表格勾选监听
     *
     * @param {type} 当前选中行对象
     *            record
     * @param {type} 行序号/索引，从0开始
     *            index
     * @returns {undefined}
     */
    tableCheck: function (selectType, record, selected, selectedRows) {
        try {
            tool.sgiLogger.log('表格勾选事件', selectType, record, selected, selectedRows);

            let { objFct } = this.props;
            // let onRowCheck = this.data.functions.onRowCheck;
            let onRowCheck = getFunctionByKey(this, "onRowCheck");
            if (onRowCheck) {
                onRowCheck(this, objFct, selectType, record, selected, selectedRows);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 选项卡切换监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    tcl: function (activeKey) {
        try {
            tool.sgiLogger.log('Tab切换事件');
            var { objFct } = this.props;
            this.setState({ activeKey });
            // let tcl = this.data.functions.tab;
            let tcl = getFunctionByKey(this, "tab");
            if (tcl) {
                tcl(this, objFct, activeKey);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 层叠面板展开事件监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    expd: function (key) {
        try {
            tool.sgiLogger.log('折叠面板事件', key);
            // tool.sgiLogger.log('arguments', arguments);
            var { objFct } = this.props;
            this.setState({ activeKey: key });
            // let expandLsn = this.data.functions.expandLsn;
            let expandLsn = getFunctionByKey(this, "expandLsn");
            if (expandLsn) {
                expandLsn(this, objFct, key);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
    * 页面后处理事件
    *
    * @param {object}
    *            ctn 容器对象
    * @returns {undefined}
    */
    ctnAfter: function (ctn) {
        try {
            tool.sgiLogger.log(arguments);
            // let tcl = this.data.functions.tab;
            let tcl = getFunctionByKey(this, "tab");
            if (tcl) {
                tcl();
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 页面关闭事件监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    ctnCls: function (e) {
        try {
            tool.sgiLogger.log('弹出窗关闭事件', e);
            var { objFct } = this.props;
            // let afterClose = this.data.functions.afterClose;
            let afterClose = getFunctionByKey(this, "afterClose");
            if (afterClose) {
                afterClose(this, objFct, e);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 页面销毁前事件监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    ctnBfRmv: function (ctn) {
        try {

        } catch (error) {

        }
    },
    /**
     * 页面初始化监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    init: function (ctn) {
        try {

        } catch (error) {

        }
    },
    /**
     * 菜单前处理监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    onbfsw: function (ctn) {
        try {

        } catch (error) {

        }
    },
    /**
     * 页面折叠监听器
     *
     * @param {object}
     *            ctn 容器对象
     * @returns {undefined}
     */
    clp: function (ctn) {
        try {

        } catch (error) {

        }
    },

    /**
     * 日历选择事件
     * @param {moment} e 当前选择的moment
     */
    calendarOnSelect: function (e) {
        try {
            tool.sgiLogger.log('日历选择事件');
            const { objFct } = this.props;
            // const onSelect = this.data.functions.onSelect;
            let onSelect = getFunctionByKey(this, "onSelect");
            if (onSelect) {
                const value = e.format('YYYY-MM-DD');
                onSelect(this, objFct, value, e);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 日历面板切换事件
     * @param {moment} e 当前选择的moment
     * @param {string} e2 当前选择的mode
     */
    calendarOnPanelChange: function (e, e2) {
        try {
            tool.sgiLogger.log('日历面板切换事件');
            const { objFct } = this.props;
            // const onPanelChange = this.data.functions.onPanelChange;
            let onPanelChange = getFunctionByKey(this, "onPanelChange");
            if (onPanelChange) {
                const value = e.format('YYYY-MM-DD');
                onPanelChange(this, objFct, value, e, e2);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },
    /**
     * 日历修改事件
     * @param {moment} e 当前选择的moment
     */
    calendarOnChange: function (e) {
        try {

            // 更新选择日期
            // this.state.value = e;
            this.setMoment(e);

            tool.sgiLogger.log('日历修改事件');
            const { objFct } = this.props;
            // const onChange = this.data.functions.onChange;
            let onChange = getFunctionByKey(this, "onChange");
            if (onChange) {
                const value = e.format('YYYY-MM-DD');
                onChange(this, objFct, value, e);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },

    /**
     * 图表点击事件
     * @param {*} params 事件参数，即事件对象的数据的各个属性
     */
    eChartsEvent: function (params) {
        try {
            tool.sgiLogger.log('图表事件入口');

            var { objFct } = this.props;
            var data = params.data;
            var seriesName = params.seriesName;
            // let getOn = this.data.functions.getOn;
            let getOn = getFunctionByKey(this, "getOn");
            if (getOn) {
                getOn(this, data, seriesName, objFct, params);
            }
        } catch (error) {
            sgiLogger.eventErr(error);
        }
    },

}

// 这里的不用了，统一使用sgiBaseComp/SgiCommon中的
// /**
//  * 统一获取事件，优先从事件集中获取，其次是旧模式
//  * @param {object} module 
//  * @param {string} eventKey 事件名
//  */
// function getFunctionByKey(module, eventKey) {
//     if (!module) return null;
//     let { objFct, moduleDesc } = module.props;
//     if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys[eventKey]) {
//         // 事件集模式
//         let funs = Object.assign({}, objFct.get("@funs"), module.funs);
//         let key = moduleDesc.eventKeys[eventKey];
//         return funs[key];
//     } else {
//         // 原事件模式
//         // return module.data.functions[eventKey];
//         // let functions = module.data && module.data.functions || module.state.functions || {};
//         // return functions[eventKey];
//         return (module.data && module.data.functions && module.data.functions[eventKey]) || (module.state.functions && module.state.functions[eventKey]);
//     }
// }

/**
 * form下控件的通过用change事件
 * @param {控件绑定属性名称} attname
 * @param {form绑定的数据key} bdInst
 * @param {对象工厂} objFct
 * @param {事件描述} e
 */
var handleOnChange = function (currentModule, attname, bdInst, objFct, e) {
    var value = e.target.value;
    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
* form下文件控件的通过用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnFileChange = function (currentModule, attname, bdInst, objFct, e) {
    //拼装value，逗号分隔
    let fileList = e.fileList;
    let value = "";
    fileList.forEach(f => {
        let response = f.response || {};
        let url = response.fileDownloadUri || f.url;
        if (!url) return;
        if (!value) {
            value = url;
        } else {
            value += "," + url;
        }
    });

    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
 * form下checkbox控件的通过用change事件
 * @param {控件绑定属性名称} attname
 * @param {form绑定的数据key} bdInst
 * @param {对象工厂} objFct
 * @param {事件描述} e
 */
var handleCheckBoxGroupChange = function (currentModule, attname, bdInst, objFct, e) {
    var value = e;
    var disValue;
    if (value && value instanceof Array && value.length > 1) {
        disValue = value.join(",")
    } else if (value && value instanceof Array) {
        disValue = value[0]
    } else {
        disValue = value;
    }
    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
    return e;
}
/**
 * form下checkbox控件的通过用change事件
 * @param {控件绑定属性名称} attname
 * @param {form绑定的数据key} bdInst
 * @param {对象工厂} objFct
 * @param {事件描述} e
 */
var handleCheckBoxChange = function (currentModule, attname, bdInst, objFct, e) {
    var value = e.target.checked;
    let escape = currentModule.state.escape;
    if (escape) {//转义
        let escs = escape.split("/");
        value = value ? escs[0] : escs[1];
    }
    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
* form下数字控件的通过用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnNumberChange = function (currentModule, attname, bdInst, objFct, e) {
    var value = e;
    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
* form下数字控件的通过用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnComboxChange = function (currentModule, attname, bdInst, objFct, value, element) {
    var value = value;
    // if (mode=='onSelect'){
    //     //如果是选中,真事数据中 添加这个值，否则取消这个值
    //     currentModule.state.showValue.push(value);
    //     value = currentModule.state.showValue;
    // } else if(mode=='onDeselect'){

    // }
    var disValue;
    if (value && value instanceof Array && value.length > 1) {
        disValue = value.join(",")
    } else if (value && value instanceof Array) {
        disValue = value[0]
    } else {
        disValue = value;
    }
    // tool.sgiLogger.log(1111111111111111111111111111111);
    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
    // return value;
    let itemData, title;
    if (Object.prototype.toString.call(element) === "[object Array]") {
        // 多选
        itemData = element.map(item => item.props.itemData);
        title = element.map(item => item.props.children);
    } else {
        // 单选
        itemData = element ? element.props.itemData : undefined;
        title = element ? element.props.children : undefined;
    }
    return { value, title, itemData };
}
/**
* form下级联控件的通用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnCascaderChange = function (currentModule, attname, bdInst, objFct, values, items) {
    currentModule.ctlRefresh(attname, bdInst, objFct, values);
    // return values;
    let titles = items.map(i => i.label);
    return { value: values, title: titles, itemData: items };
}
/**
* form下富文本的通用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnEditorChange = function (currentModule, attname, bdInst, objFct, e) {
    // let value = currentModule.getCurrentContentHtml();
    let value = e;
    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
 * tinymce富文本的change事件
 * @param {*} currentModule 
 * @param {*} attname 
 * @param {*} bdInst 
 * @param {*} objFct 
 * @param {*} content 
 * @param {*} editor 
 */
var handleOnTinyMCEChange = function (currentModule, attname, bdInst, objFct, content, editor) {
    let value = content;
    currentModule.ctlRefresh(attname, bdInst, objFct, value);
    return value;
}
/**
 * form下日期控件的通过用change事件
 * @param {控件绑定属性名称} attname
 * @param {form绑定的数据key} bdInst
 * @param {对象工厂} objFct
 * @param {更新后的值date格式} date
 * @param {更新后的值string格式} dateString
 * @param {格式} dateFormat
 */
var handleOnSelDate = function (currentModule, attname, bdInst, objFct, date, dateString, dateFormat) {

    // let newVal = "";
    // if (!dateString) {

    // } else if (Array.isArray(dateString)) {
    //     newVal = dateString.join(",");
    // } else {
    //     newVal = dateString;
    // }

    let newVal = dateString || "";
    //格式化 以后再说
    currentModule.ctlRefresh(attname, bdInst, objFct, newVal);
    return newVal;
}
/**
 * form下时间控件的通过用change事件
 * @param {控件绑定属性名称} attname
 * @param {form绑定的数据key} bdInst
 * @param {对象工厂} objFct
 * @param {更新后的值date格式} Time
 * @param {更新后的值string格式} timeString
 * @param {格式} TimeFormat
 */
var handleOnSelTime = function (currentModule, attname, bdInst, objFct, time, timeString, TimeFormat) {
    // if (dateString == null || dateString.length == 0) {
    //     dateString = '';
    // }
    //格式化 以后再说
    currentModule.ctlRefresh(attname, bdInst, objFct, timeString);
    return timeString;
}
/**
* 下拉树的通过用change事件
* @param {控件绑定属性名称} attname
* @param {form绑定的数据key} bdInst
* @param {对象工厂} objFct
* @param {事件描述} e
*/
var handleOnTreeSelectChange = function (currentModule, attname, bdInst, objFct, value, label, extra) {
    var disValue;
    var multiple = currentModule.state.inputprops.treeCheckable;// 是否多选
    if (multiple) {
        if (value && value.length > 1) {
            for (let i = 0; i < value.length; i++) {
                disValue = value.join(",")
            }
        } else {
            disValue = value[0];
        }
    } else {
        disValue = value;
    }

    currentModule.ctlRefresh(attname, bdInst, objFct, disValue);
    // return value;
    let title = (label || [])[0];
    let itemData = extra.triggerNode ? extra.triggerNode.props.itemData : undefined;
    return { value, title, itemData };
}

export { SgiEventHandler };




// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiEventHandler.js